import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { tickColor, gridColor, baseFont, STATUS_CONFIG } from './chartConstants';

const StatusBarChart = ({ ticketsCount }) => {
    const chartData = useMemo(() => {
        if (!ticketsCount) return null;
        const getValue = (key) => {
            const found = Object.entries(ticketsCount).find(([k]) => k.toLowerCase() === key.toLowerCase());
            return found ? (found[1] ?? 0) : 0;
        };
        return {
            labels:   STATUS_CONFIG.map(s => s.label),
            datasets: [{ label: 'Tickets', data: STATUS_CONFIG.map(s => getValue(s.key)), backgroundColor: STATUS_CONFIG.map(s => s.color), hoverBackgroundColor: STATUS_CONFIG.map(s => s.hover), borderWidth: 0 }],
        };
    }, [ticketsCount]);

    const options = {
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
            mode: 'index', intersect: false,
            backgroundColor: '#1F2937',
            titleFontFamily: baseFont, titleFontSize: 12, titleFontStyle: 'bold',
            bodyFontFamily: baseFont,  bodyFontSize: 12,
            xPadding: 10, yPadding: 10,
            callbacks: { label: (item) => ` ${item.yLabel} ticket${item.yLabel !== 1 ? 's' : ''}` },
        },
        scales: {
            xAxes: [{ gridLines: { display: false }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 12, fontStyle: 'bold' } }],
            yAxes: [{ gridLines: { color: gridColor }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, beginAtZero: true, callback: (v) => Number.isInteger(v) ? v : null } }],
        },
    };

    if (!chartData) return <div style={{ color: tickColor, padding: 20 }}>No status data available</div>;
    return <div style={{ height: '100%', minHeight: 160 }}><Bar data={chartData} options={options} /></div>;
};

export default StatusBarChart;
